var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"row justify-center items-center window-height"},[_c('q-circular-progress',{staticClass:"q-ma-md",attrs:{"indeterminate":"","size":"50px","color":"subdued"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }